import { Button } from "@/components/ui/baseUi/button"
import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import { useSidebar } from "@/modules/sidebar/hooks/useSidebar"
import { Plus } from "lucide-react"

type AddEventButtonProps = {
  displayText: boolean
  addEventTitle?: string
  addEventSubtitle?: string
} & React.ComponentProps<"div">

export function AddEventButton({
  displayText,
  addEventTitle,
  addEventSubtitle,
  onClick,
  ...props
}: AddEventButtonProps) {
  const { isSidebarVisible } = useSidebar()

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (isSidebarVisible) return
    e.stopPropagation()
    onClick?.(e)
  }
  return (
    <div
      className={cn(
        "add flex cursor-pointer flex-col justify-center text-center",
        { "add-hidden cursor-default! *:pointer-events-none": isSidebarVisible },
        props.className,
      )}
      onClick={handleClick}
      {...props}
    >
      {displayText && (addEventTitle ?? addEventSubtitle) && (
        <>
          {addEventTitle && <Text fontStyle="TL">{addEventTitle}</Text>}
          {addEventSubtitle && (
            <Text fontStyle="BS" className="leading-none">
              {addEventSubtitle}
            </Text>
          )}
        </>
      )}
      {!displayText && addEventTitle ? (
        <Button variant="outline" size="xs" className="self-center p-2">
          <Plus />
          {addEventTitle}
        </Button>
      ) : (
        <Button variant="outline" size="iconMd" className="self-center p-2">
          <Plus />
        </Button>
      )}
    </div>
  )
}
